<template>
  <div class="mb-6">
    <h4>{{ title }}</h4>
    <Markdown class="privacy-text text-xs text-muted">
      {{ privacyText }}
    </Markdown>
  </div>
</template>
<script>
import Markdown from "./Markdown";

export default {
  name: "LunchMenuPrivacy",
  components: { Markdown },
  props: {
    privacyText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "~styles/global";

.privacy-text {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: $h6-font-size;
  }
}
</style>
